import script from "./MagazineOptions.vue?vue&type=script&setup=true&lang=js"
export * from "./MagazineOptions.vue?vue&type=script&setup=true&lang=js"

import "./MagazineOptions.vue?vue&type=style&index=0&id=39a3122e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39a3122e"]])

export default __exports__